import React, { useContext, useEffect, useState } from "react";
import './InputField.css';
import { NumericFormat } from 'react-number-format';
import ReactInputMask from "react-input-mask";
import { useRef } from "react";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from "react-phone-input-2";

const InputField = ({
    setAttribute,
    style,
    type,
    value,
    checked,
    disabled,
    readOnly,
    mask,
    className = 'input-field',
    onBlur,
    focus,
    decimalScale,
    placeholder,
    countryCode
}) => {
    const inputRef = useRef(null);
    const [country, setCountry] = useState("");

    const focusInput = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        fetch("https://ipwho.is/")
            .then((res) => res.json())
            .then((data) => {
                if (data?.country_code?.toLowerCase() === "br") {
                    setCountry("br");
                }
            })
            .catch((err) => console.warn("Erro ao detectar país:", err));
    }, []);

    useEffect(() => {
        if (focus) {
            focusInput();
        }
    }, [focus]);

    const handleSelectChange = (lookupChanged, id) => {
        lookupChanged(id)
    }

    const handleChange = (e) => {
        handleSelectChange(setAttribute, e.target.value);
    };

    if (mask === 'money') {
        return (
            <NumericFormat
                value={value}
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                decimalScale={2}
                fixedDecimalScale={true}
                onValueChange={(values) => {
                    const { floatValue } = values;
                    if (floatValue) {
                        setAttribute(floatValue);
                    } else {
                        setAttribute('');
                    }
                }}
                type="text"
                className="input-field"
                checked={checked}
                disabled={disabled}
                readOnly={readOnly}
                style={style}
                onBlur={onBlur}
                ref={focus ? inputRef : null}
            />
        );
    }

    if (mask && mask.toUpperCase() === 'CNPJ') {
        let className = "input-field";

        if (disabled) {
            className += " disabled";
        }

        return (
            <ReactInputMask
                id="cpf"
                mask="99.999.999/9999-99"
                value={value}
                onChange={!readOnly ? handleChange : null}
                inputRef={focus ? inputRef : null}
                disabled={disabled}
                readOnly={readOnly}
            >
                {(inputProps) =>
                    <input
                        {...inputProps}
                        type="text"
                        className={className}
                        style={style}
                    />}
            </ReactInputMask>
        );
    }

    if (decimalScale) {
        return (
            <NumericFormat
                value={value}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={decimalScale}
                fixedDecimalScale={true}
                onValueChange={(values) => {
                    const { floatValue } = values;
                    if (floatValue) {
                        setAttribute(floatValue);
                    } else {
                        setAttribute('');
                    }
                }}
                type="text"
                className="input-field"
                checked={checked}
                disabled={disabled}
                readOnly={readOnly}
                style={style}
                onBlur={onBlur}
                ref={focus ? inputRef : null}
            />
        );
    }

    if (mask && mask.toUpperCase() === 'CPF') {
        let className = "input-field";

        if (disabled) {
            className += " disabled";
        }

        return (
            <ReactInputMask
                id="cpf"
                mask="999.999.999-99"
                value={value}
                onChange={!readOnly ? handleChange : null}
                inputRef={focus ? inputRef : null}
                disabled={disabled}
                readOnly={readOnly}
            >
                {(inputProps) =>
                    <input
                        {...inputProps}
                        type="text"
                        className={className}
                        style={style}
                    />}
            </ReactInputMask>
        );
    }

    if (mask && mask.toUpperCase() === 'PHONE_NUMBER') {
        return (
            <PhoneInput
                country={null}
                onFocus={() => {
                    if (!value && country === 'br') {
                        setAttribute('+55');
                    }
                }}
                value={value}
                onChange={(val) => setAttribute(val)}
                inputStyle={{ width: '195px' }}
                enableSearch
                placeholder={'(99) 99999-9999'}
                masks={{ br: '(..) .....-....' }}
                localization={{
                    br: 'Brasil',
                    us: 'Estados Unidos',
                    gb: 'Reino Unido',
                    fr: 'França',
                    de: 'Alemanha',
                    search: 'Buscar',
                }}
                disableDropdown={readOnly}
                inputProps={{
                    readOnly,
                    disabled,
                    onBlur,
                }}
            />
        );
    }

    if (mask && mask.toUpperCase() === 'CEP') {
        let className = "input-field";

        if (disabled) {
            className += " disabled";
        }

        return (
            <ReactInputMask
                mask="99999-999"
                value={value}
                onChange={!readOnly ? handleChange : null}
                inputRef={focus ? inputRef : null}
                disabled={disabled}
                readOnly={readOnly}
            >
                {(inputProps) =>
                    <input
                        {...inputProps}
                        type="text"
                        className={className}
                        style={style}
                        placeholder={"00000-000"}
                        onBlur={onBlur}
                    />
                }
            </ReactInputMask>
        );
    }

    let mainStyle;
    if (type === 'checkbox') {
        mainStyle = {
            width: '30px'
        }
    }

    return (
        <input
            className={className}
            onChange={(e) => { handleSelectChange(setAttribute, e.target.value) }}
            type={type}
            value={value}
            checked={checked}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={placeholder}
            style={{ ...style, ...mainStyle }}
            onBlur={onBlur}
            ref={focus ? inputRef : null}
        />
    );

};

export default InputField;
